<div id="pias-convention-container" class="container-fluid">
  <!-- Sprinner -->
  @if(this.setSprinner()) {
  <div class="pias-spinner">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  }
  <!-- <div id="pias-convention-header">
        <h5 class="page-header">PIAS Convention 2025</h5>
    </div> -->
  <div id="pias-convention-card-container" class="row justify-content-around">
    <!-- PIAS Convention Personal Qualification -->
    <!-- <div id="pias-convention-personal-qualification-card" class="col-sm-12 col-md-10 col-lg-6 col-xxl-6">
            <mat-card appearance="raised" class="pias-card">
                <mat-card-header class="pias-card-header">
                    <mat-card-title class="pias-card-title">Personal Qualification</mat-card-title>
                </mat-card-header>
                <mat-card-content class="pias-card-content">
                    <div class="pias-card-content-container row">
                        <div class="pias-card-content-set pias-card-border-left col-6">
                            <div class="pias-card-content-header text-center">Life Insurance</div>
                            <div class="pias-card-content-body">{{"234560" |
                                currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                            <div class="mt-2"></div>
                            <div class="pias-card-content-header text-center">Investment</div>
                            <div class="pias-card-content-body">{{"9726979" |
                                currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                        </div>
                        <div class="pias-card-content-set col-6">
                            <div class="pias-card-content-header text-center">GI</div>
                            <div class="pias-card-content-body">{{"781082" |
                                currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                            <div class="mt-2"></div>
                            <div class="pias-card-content-header text-center">Fees & Referrals</div>
                            <div class="pias-card-content-body">{{"9708607" |
                                currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                        </div>
                    </div>
                    <mat-divider class="pias-card-divider"></mat-divider>
                    <div class="pias-card-content-container row">
                        <div class="pias-card-content-set col-6">
                            <div class="pias-card-content-header total-text">Total</div>
                        </div>
                        <div class="pias-card-content-set col-6">
                            <div class="pias-card-content-body total-text">{{"9739739" |
                                currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                        </div>
                    </div>
                    <mat-divider class="pias-card-divider"></mat-divider>
                    <div class="pias-card-content-container row">
                        <div class="pias-card-content-set col-6">
                            <div class="pias-card-content-header text-center">Target</div>
                            <div class="pias-card-content-body">{{"781082" |
                                currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                        </div>
                        <div class="pias-card-content-set col-6">
                            <div class="pias-card-content-header text-center">Shortfall / Overachieve</div>
                            <div class="pias-card-content-body text-overachieve">{{"781082" |
                                currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div> -->

    <!-- PIAS Convention Investment Club -->
    <!-- <div id="pias-convention-investment-clud-card" class="col-sm-12 col-md-10 col-lg-6 col-xxl-6">
            <mat-card appearance="raised" class="pias-card">
                <mat-card-header class="pias-card-header">
                    <mat-card-title class="pias-card-title">Investment Club Qualification (Only Top 10 will Qualify)</mat-card-title>
                </mat-card-header>
                <mat-card-content class="pias-card-content">
                    <div class="pias-card-content-container row">
                        <div class="pias-card-content-set pias-card-border-left col-6">
                            <div class="pias-card-content-header text-center">Grow</div>
                            <div class="pias-card-content-body">{{"234560" |
                                currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                        </div>
                        <div class="pias-card-content-set col-6">
                            <div class="pias-card-content-header text-center">iFast</div>
                            <div class="pias-card-content-body">{{"781082" |
                                currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                        </div>
                        <div class="pias-card-content-set pias-card-border-left col-6">
                            <div class="pias-card-content-header text-center">&nbsp;</div>
                            <div class="pias-card-content-body">&nbsp;</div>
                        </div>
                        <div class="pias-card-content-set col-6">
                            <div class="pias-card-content-header text-center">&nbsp;</div>
                            <div class="pias-card-content-body">&nbsp;</div>
                        </div>
                    </div>
                    <mat-divider class="pias-card-divider"></mat-divider>
                    <div class="pias-card-content-container row">
                        <div class="pias-card-content-set col-6">
                            <div class="pias-card-content-header total-text">Total Net Inflow (New)</div>
                        </div>
                        <div class="pias-card-content-set col-6">
                            <div class="pias-card-content-body total-text">{{"9739739" |
                                currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                        </div>
                    </div>
                    <mat-divider class="pias-card-divider"></mat-divider>
                    <div class="pias-card-content-container row">
                        <div class="pias-card-content-set col-6">
                            <div class="pias-card-content-header text-center">Target</div>
                            <div class="pias-card-content-body">{{"781082" |
                                currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                        </div>
                        <div class="pias-card-content-set col-6">
                            <div class="pias-card-content-header text-center">Shortfall / Overachieve</div>
                            <div class="pias-card-content-body text-overachieve">{{"781082" |
                                currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div> -->

    <!-- PIAS Convention Table Containers-->
    <div id="pias-convention-by-advisor-table-container">
      <!-- Personal Qualification By Advisor Table -->
      <mat-accordion class="pias-accordian">
        <mat-expansion-panel class="pias-expansion-panel" [expanded]="false">
          <mat-expansion-panel-header class="pias-expansion-panel-header">
            <mat-panel-title class="pias-expansion-panel-title">
              <h5 class="header">PIAS - Personal Qualification</h5>
              <div class="p-2 d-flex justify-content-center align-items-center">
                @if(!this.isQualifiedAdvisorsCountHidden()) {
                <i class="bx bx-clipboard-check header-icon me-2"></i>
                <div class="label-text">Total Advisers Qualified:<span
                    class="label-value">{{this.totalPersonalQualifiedAdvisorsCount}}</span></div>
                }
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!-- Personal Qualification  Data Filtering -->
          <!-- <mat-form-field class="w-100">
                        <mat-label>Search Personal Qualification </mat-label>
                        <input type="text" matInput [formControl]="personalQualificationByAdvisorTableFilterFc"
                            (keyup)="__applyPersonalQualificationByAdvisorDataFilter()"
                            placeholder="Ex. Rep. code, name" />
                    </mat-form-field> -->
          <div class="row align-items-start g-3">
            <div class="col-12 col-lg-6">
              <div id="personal-convention-filter" class="position-relative" style="max-width: 400px"
                [hidden]="this.isQualificationTableFilterAndPaginatorHidden()">
                <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                  style="background: #f0f0f0; color: #1c3a7a"
                  [formControl]="personalQualificationByAdvisorTableFilterFc"
                  (keyup)="__applyPersonalQualificationByAdvisorDataFilter()"
                  placeholder="Search Personal Qualification..." #input />

                <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y" style="color: #888888"></i>

                <button *ngIf="personalQualificationByAdvisorTableFilterFc.value"
                  class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                  (click)="clearSearch()">
                  <i class="fas fa-times" style="color: #888888"></i>
                </button>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="container qualification-legend">
  <div class="legend-card p-2 border rounded bg-white">

    <!-- Row 1 -->
    <div class="row row-cols-3 g-2 mb-1">
      <div class="col">
        <div class="legend-item">
          <span class="dot met-main"></span>
          <span>Main <b>130,000</b></span>
        </div>
      </div>

      <div class="col">
        <div class="legend-item">
          <span class="dot met-vip-1"></span>
          <span>VIP x 1 <b>230,000</b> </span>
        </div>
      </div>

      <div class="col">
        <div class="legend-item">
          <span class="dot met-vip-2"></span>
          <span>VIP x 2 <b>330,000</b></span>
        </div>
      </div>
    </div>

    <!-- Row 2 -->
    <div class="row row-cols-1 row-cols-md-2 g-2">
      <div class="col">
        <div class="legend-item">
          <span class="dot met-invt"></span>
          <span>Met (Invt) – <b>Qualified under investment</b></span>
        </div>
      </div>

      <div class="col">
        <div class="legend-item">
          <span class="dot resigned"></span>
          <span>N/A – <b>Resigned / Serving Notice</b></span>
        </div>
      </div>
    </div>

  </div>
</div>


              <!-- <div class="card" [hidden]="this.isQualifiedAdvisorsCountHidden()">
                <div class="card-body d-flex justify-content-center align-items-center">
                  <i class="bx bx-clipboard-check header-icon me-2"></i>
                  <span class="label-text">Total Advisers Qualified -
                    {{this.totalPersonalQualifiedAdvisorsCount}}</span>
                </div>
              </div> -->
            </div>
            <mat-divider class="pias-divider"
              [hidden]="this.isQualificationTableFilterAndPaginatorHidden()"></mat-divider>
          </div>

          <!-- Personal Qualification  List Table -->
          <div id="personal-qualification-table" class="pias-table-container">
            <table mat-table class="pias-table table table-hover table-bordered bg-light border border-2"
              [dataSource]="personalQualificationByAdvisorTableDataSource" matSort #personalQualificationByAdvisorSort="matSort" matSortDisableClear="false">
              <!--matSortDisableClear
              matSortActive="totalNetInflowNew" matSortDirection="desc"-->
              <!-- Rep. Code Column -->
              <ng-container matColumnDef="repCode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Rep. Code
                </th>
                <td mat-cell *matCellDef="let pqData" class="text-start" style="max-width: 100px;">{{ pqData.repCode }}
                </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="personName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Name
                </th>
                <td mat-cell *matCellDef="let pqData" class="text-start" style="max-width: 150px;">
                  {{ pqData.personName }}
                </td>
              </ng-container>

              <!-- Branch Column -->
              <ng-container matColumnDef="branch">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Branch
                </th>
                <td mat-cell *matCellDef="let pqData" class="text-start" style="max-width: 200px;">
                  {{ pqData.branch }}
                </td>
              </ng-container>

              <!-- Life Insurance Column -->
              <ng-container matColumnDef="lifeInsurance">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Life <br> Insurance
                </th>
                <td mat-cell *matCellDef="let pqData" class="text-end">
                  {{ pqData.lifeInsurance | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
                </td>
              </ng-container>

              <!-- Investment Column -->
              <ng-container matColumnDef="investment">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Investment
                </th>
                <td mat-cell *matCellDef="let pqData" class="text-end">
                  {{ pqData.investment | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
                </td>
              </ng-container>

              <!-- General Insurance Column -->
              <ng-container matColumnDef="generalInsurance">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  General <br> Insurance
                </th>
                <td mat-cell *matCellDef="let pqData" class="text-end">
                  {{ pqData.generalInsurance | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
                </td>
              </ng-container>

              <!-- Fee And Referrals Column -->
              <ng-container matColumnDef="feeAndReferral">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Fees <br> & Referrals
                </th>
                <td mat-cell *matCellDef="let pqData" class="text-end">
                  {{ pqData.feeAndReferral | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
                </td>
              </ng-container>

              <!-- Total Column -->
              <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Total
                </th>
                <td mat-cell *matCellDef="let pqData" class="text-end">
                  {{ pqData.total | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
                </td>
              </ng-container>

              <!-- Target Column -->
              <ng-container matColumnDef="target">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Target
                </th>
                <td mat-cell *matCellDef="let pqData" class="text-end">
                  {{ pqData.target | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
                </td>
              </ng-container>

              <!-- Shortfall Column -->
              <ng-container matColumnDef="shortfall">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Shortfall
                </th>
                <td mat-cell *matCellDef="let pqData" class="text-end">
                  {{ pqData.shortfall | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
                </td>
              </ng-container>

              <!-- Met/Not Met Column -->
              <ng-container matColumnDef="metOrNotmet">
                <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold">
                  Met <br> /Not Met
                </th>
                <td mat-cell *matCellDef="let pqData" class="d-flex justify-content-center">
                  @if(pqData.qualificationStatus === this.QualificationStatus.MET_VIP_2) {
                  <span class="qualification-status met-vip-2">VIP x 2</span>
                  }
                  @else if(pqData.qualificationStatus === this.QualificationStatus.MET_VIP_1) {
                  <span class="qualification-status met-vip-1">VIP x 1</span>
                  }
                  @else if(pqData.qualificationStatus === this.QualificationStatus.MET_MAIN) {
                  <span class="qualification-status met-main">Main</span>
                  }
                  @else if(pqData.qualificationStatus === this.QualificationStatus.MET_INVT) {
                  <span class="qualification-status met-invt">Met (Invt)</span>
                  }
                  @else if(pqData.qualificationStatus === this.QualificationStatus.NOT_MET) {
                  <span class="qualification-status not-met">Not Met</span>
                  }
                  @else if(pqData.qualificationStatus === this.QualificationStatus.RESIGNED) {
                  <span class="qualification-status resigned">N/A</span>
                  }
                  @else {
                  <span class="qualification-status not-met">Not Met</span>
                  }
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="personalQualificationByAdvisorTableDisplayColumn; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: personalQualificationByAdvisorTableDisplayColumn"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="7">No data found.</td>
              </tr>
            </table>
          </div>
          <mat-action-row class="p-2 d-flex justify-content-between align-items-start qualification-action-row"
            [hidden]="this.isQualificationTableFilterAndPaginatorHidden()">
            <!-- Left: Disclaimer -->
            <p class="comment-content">
              <b>Disclaimer:</b>
              {{this.conventionPersonalQualificationDisclaimer}}
            </p>

            <!-- Right: Paginator -->
            <mat-paginator #personalQualificationByAdvisorPaginator [pageSizeOptions]="[10, 20, 50]"
              showFirstLastButtons aria-label="Select page of gross revenue by advisor data">
            </mat-paginator>
          </mat-action-row>

        </mat-expansion-panel>
      </mat-accordion>

      <mat-divider class="pias-divider"></mat-divider>
      <!-- Club Qualification By Advisor Table -->
      <mat-accordion class="pias-accordian">
        <mat-expansion-panel class="pias-expansion-panel" [expanded]="false">
          <mat-expansion-panel-header class="pias-expansion-panel-header">
            <mat-panel-title class="pias-expansion-panel-title">
              <h5 class="header">PIAS - Investment Club Qualification (Only Top 10 will Qualify)</h5>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!-- Club Qualification  Data Filtering -->
          <!-- <mat-form-field class="w-100">
                        <mat-label>Search Club Qualification </mat-label>
                        <input type="text" matInput [formControl]="clubQualificationByAdvisorTableFilterFc"
                            (keyup)="__applyClubQualificationByAdvisorDataFilter()" placeholder="Ex. Rep. code, name" />
                    </mat-form-field> -->
          <div class="row align-items-start g-3">
            <div class="col-12 col-lg-6">
              <div id="club-qualification-filter" class="position-relative" style="max-width: 400px"
                [hidden]="this.isQualificationTableFilterAndPaginatorHidden()">
                <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                  style="background: #f0f0f0; color: #1c3a7a" [formControl]="clubQualificationByAdvisorTableFilterFc"
                  (keyup)="__applyClubQualificationByAdvisorDataFilter()" placeholder="Search Club Qualification..."
                  #input />

                <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y" style="color: #888888"></i>

                <button *ngIf="clubQualificationByAdvisorTableFilterFc.value"
                  class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                  (click)="clearClubSearch()">
                  <i class="fas fa-times" style="color: #888888"></i>
                </button>
              </div>
            </div>
            <div class="col-12 col-lg-6">
                      <div class="container qualification-legend">
  <div class="legend-card p-1 border rounded bg-white">
       <div class="row g-2">
      
      <!-- Column 1 -->
      <div class="col-md-6">
       <div class="legend-item">
          <span class="dot met-vip-1 me-2"></span>
          <div>VIP x 1 <b>Top 3</b></div>
        </div>

       <div class="legend-item">
          <span class="dot met-gr me-2"></span>
          <div>Met (GR) – <b>Qualified under GR</b></div>
        </div>
        <div class="legend-item">
          <span class="dot resigned me-2"></span>
          <div>N/A – <b>Resigned / Serving Notice</b></div>
        </div>
      </div>

      <!-- Column 2 -->
      <div class="col-md-6">
        <div class="legend-item">
           <span class="dot met-main me-2"></span>
          <div>Main <b>Top 4 – 10</b></div>
        </div>
          

       <div class="legend-item">
          <span class="dot met-nq me-2"></span>
          <div>Met (NQ) – <b>Not under Top 10</b></div>
        </div>
      </div>

    </div>
  </div>
</div>
              <!-- <div class="qualification-legend">
                <div class="legend-card ms-md-auto">
                  <div class="legend-row">
                    <div class="legend-header">
                      TARGET
                    </div>

                    <div class="legend-items">
                      <div class="legend-item">
                        <span class="dot met-vip-1"></span>
                        <span>VIP x 1</span>
                        <span class="amount">- Top 3</span>
                      </div>

                      <div class="legend-item">
                        <span class="dot met-main"></span>
                        <span>Main</span>
                        <span class="amount">- Top 4 - 10</span>
                      </div>
                      <div class="legend-item">
                        <span class="dot met-gr"></span>
                        <span>Met(GR)</span>
                        <span class="amount">- Qualified under GR</span>
                      </div>

                      <div class="legend-item">
                        <span class="dot met-nq"></span>
                        <span>Met(NQ)</span>
                        <span class="amount">- Not under Top 10</span>
                      </div>

                      <div class="legend-item">
                        <span class="dot resigned"></span>
                        <span>N/A</span>
                        <span class="amount">- Resigned / Serving Notice</span>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- <div class="card" [hidden]="this.isQualifiedAdvisorsCountHidden()">
                <div class="card-body d-flex justify-content-center align-items-center">
                  <i class="bx bx-clipboard-check header-icon me-2"></i>
                  <span class="label-text">Total Advisers Qualified -
                    {{this.totalPersonalQualifiedAdvisorsCount}}</span>
                </div>
              </div> -->
            </div>
          </div>
          <mat-divider class="pias-divider"
            [hidden]="this.isQualificationTableFilterAndPaginatorHidden()"></mat-divider>

          <!-- Club Qualification  List Table -->
          <div id="club-qualification-table" class="pias-table-container">
            <table mat-table class="pias-table table table-hover table-bordered bg-light border border-2"
              [dataSource]="clubQualificationByAdvisorTableDataSource" matSort #clubQualificationByAdvisorSort="matSort" matSortDisableClear="false">
<!--matSortDisableClear
              matSortActive="totalNetInflowNew" matSortDirection="desc"-->
              <!-- Rep. Code Column -->
              <ng-container matColumnDef="repCode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Rep. Code
                </th>
                <td mat-cell *matCellDef="let cqData" class="text-start" style="max-width: 100px;">{{ cqData.repCode }}
                </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="personName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Name
                </th>
                <td mat-cell *matCellDef="let cqData" class="text-start" style="max-width: 150px;">
                  {{ cqData.personName }}
                </td>
              </ng-container>

              <!-- Branch Column -->
              <ng-container matColumnDef="branch">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Branch
                </th>
                <td mat-cell *matCellDef="let cqData" class="text-start" style="max-width: 200px;">
                  {{ cqData.branch }}
                </td>
              </ng-container>

              <!-- Grow Column -->
              <ng-container matColumnDef="grow">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Grow
                </th>
                <td mat-cell *matCellDef="let cqData" class="text-end">
                  {{ cqData.grow | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
                </td>
              </ng-container>

              <!-- iFast Column -->
              <ng-container matColumnDef="ifast">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  iFast
                </th>
                <td mat-cell *matCellDef="let cqData" class="text-end">
                  {{ cqData.ifast | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
                </td>
              </ng-container>

              <!-- Total Net Inflow (New) Column -->
              <ng-container matColumnDef="totalNetInflowNew">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Total <br> Net Inflow (New)
                </th>
                <td mat-cell *matCellDef="let cqData" class="text-end">
                  {{ cqData.totalNetInflowNew | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
                </td>
              </ng-container>

              <!-- Target Column -->
              <ng-container matColumnDef="target">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Target
                </th>
                <td mat-cell *matCellDef="let cqData" class="text-end">
                  {{ cqData.target | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
                </td>
              </ng-container>

              <!-- Shortfall Column -->
              <ng-container matColumnDef="shortfall">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                  Shortfall
                </th>
                <td mat-cell *matCellDef="let cqData" class="text-end">
                  {{ cqData.shortfall | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
                </td>
              </ng-container>

              <!-- Met/Not Met Column -->
              <ng-container matColumnDef="metOrNotmet">
                <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold">
                  Met <br> /Not Met
                </th>
                <td mat-cell *matCellDef="let cqData" class="d-flex justify-content-center">
                  @if(cqData.qualificationStatus === this.QualificationStatus.MET_VIP_1) {
                  <span class="qualification-status met-vip-1">VIP x 1</span>
                  }
                  @else if(cqData.qualificationStatus === this.QualificationStatus.MET_MAIN) {
                  <span class="qualification-status met-main">Main</span>
                  }
                  @else if(cqData.qualificationStatus === this.QualificationStatus.MET_NQ) {
                  <span class="qualification-status met-nq">Met (NQ)</span>
                  }
                  @else if(cqData.qualificationStatus === this.QualificationStatus.MET_GR) {
                  <span class="qualification-status met-gr">Met (GR)</span>
                  }
                  @else if(cqData.qualificationStatus === this.QualificationStatus.NOT_MET) {
                  <span class="qualification-status not-met">Not Met</span>
                  }
                  @else if(cqData.qualificationStatus === this.QualificationStatus.RESIGNED) {
                  <span class="qualification-status resigned">N/A</span>
                  }
                  @else {
                  <span class="qualification-status not-met">Not Met</span>
                  }
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="clubQualificationByAdvisorTableDisplayColumn; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: clubQualificationByAdvisorTableDisplayColumn"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="7">No data found.</td>
              </tr>
            </table>
          </div>
          <mat-action-row class="p-2 d-flex justify-content-between align-items-start qualification-action-row"
            [hidden]="this.isQualificationTableFilterAndPaginatorHidden()">
            <!-- Left: Disclaimer -->
            <p class="comment-content">
              <b>Disclaimer:</b>
              {{this.conventionClubQualificationDisclaimer}}
            </p>
            <!-- Club Qualification  Table Paginator -->
            <mat-paginator #clubQualificationByAdvisorPaginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons
              aria-label="Select page of Club Qualification by advisor data"></mat-paginator>
          </mat-action-row>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>